import React, { Component } from "react";
import { connect } from "react-redux";
import { NavItem, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";

import IntlMessages from "../../../helpers/IntlMessages";
import ApplicationMenu from "../../../components/common/ApplicationMenu";

class TreasuryApplicationMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      priceRange: [
        { label: "price.under-1m", value: 1000000 },
        { label: "price.1m-to-10m", value: 5000000 },
        { label: "price.over-10m", value: 10000000 },
      ],
    };
  }

  render() {
    const { priceRange } = this.state;
    const { data, filter, filterData } = this.props;

    // const personAdd = data?.map((person) => person.user.fullname);
    // const personUnique = [...new Set(personAdd)];

    // console.log('personUnique: ', personUnique);

    return (
      <ApplicationMenu>
        <PerfectScrollbar
          options={{ suppressScrollX: true, wheelPropagation: false }}
        >
          <div className="p-4">
            <NavItem
              className={classnames(
                {
                  active: !filter,
                },
                "mb-5",
              )}
            >
              <NavLink
                location={{}}
                to="#"
                onClick={(e) => filterData("", "")}
                className="d-flex justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center">
                  <i className="simple-icon-check mr-10" />
                  <span>
                    <IntlMessages id="general.all" />
                  </span>
                </div>
                <span className="float-right">{data?.length}</span>
              </NavLink>
            </NavItem>
            <p className="text-muted text-small">
              <IntlMessages id="menu.finance.include-statistics" />
            </p>
            <ul className="list-unstyled mb-5">
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "time" &&
                    filter.value === "now",
                })}
              >
                <NavLink
                  location={{}}
                  to="#"
                  onClick={(e) => filterData("time", "now")}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <i className="simple-icon-check" />
                    <span>
                      <IntlMessages id="general.yes" />
                    </span>
                  </div>
                  <span className="float-right">
                    {data?.filter((x) => x.time === "now").length}
                  </span>
                </NavLink>
              </NavItem>
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "time" &&
                    filter.value === "since",
                })}
              >
                <NavLink
                  to="#"
                  location={{}}
                  onClick={(e) => filterData("time", "since")}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <i className="simple-icon-close" />
                    <span>
                      <IntlMessages id="general.no" />
                    </span>
                  </div>
                  {/* <IntlMessages id='todo.completed-tasks' /> */}
                  <span className="float-right">
                    {data?.filter((x) => x.time === "since").length}
                  </span>
                </NavLink>
              </NavItem>
            </ul>
            <p className="text-muted text-small">
              <IntlMessages id="menu.finance.price-range" />
            </p>
            <ul className="list-unstyled mb-5">
              {priceRange?.map((c, index) => {
                return (
                  <NavItem key={index}>
                    <div onClick={(e) => filterData("price", c.value)}>
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                          className="custom-control-input"
                          defaultChecked={
                            filter &&
                            filter.column === "price" &&
                            filter.value === c.value
                          }
                        />
                        <label className="custom-control-label">
                          <IntlMessages id={c.label} />
                        </label>
                      </div>
                    </div>
                  </NavItem>
                );
              })}
            </ul>
            <p className="text-muted text-small">
              <IntlMessages id="menu.finance.creator" />
            </p>
            <ul className="list-unstyled mb-5">
              {/* {personUnique?.map((c, index) => {
                                const fullname = c.fullname;
                                return (
                                    <NavItem key={index}>
                                        <div
                                            onClick={(e) =>
                                                filterData('fullname', c)
                                            }
                                        >
                                            <div className='custom-control custom-radio'>
                                                <input
                                                    type='radio'
                                                    className='custom-control-input'
                                                    defaultChecked={
                                                        filter &&
                                                        filter.column ===
                                                            'fullname' &&
                                                        filter.value === c
                                                    }
                                                />
                                                <label className='custom-control-label'>
                                                    {c}
                                                </label>
                                            </div>
                                        </div>
                                    </NavItem>
                                );
                            })} */}
            </ul>
          </div>
        </PerfectScrollbar>
      </ApplicationMenu>
    );
  }
}

export default TreasuryApplicationMenu;
